import type { CoreElement } from '@tunasong/schemas'

/**
 * What was typed but not sent, per entity and thread, kept for the session (chat tasks M5.4; spec §10.8): the panel
 * and the full page are two composers for one Chat, so a draft carries across both ways. The key is
 * `${entityId}:${threadId ?? ''}`.
 */
const drafts = new Map<string, CoreElement[]>()

export const composerDraft = (key: string) => drafts.get(key)

export const setComposerDraft = (key: string, value: CoreElement[] | undefined) => {
  if (value) {
    drafts.set(key, value)
    return
  }
  drafts.delete(key)
}
